import { render, staticRenderFns } from "./EmployeeForm.vue?vue&type=template&id=01217aa1&scoped=true"
import script from "./EmployeeForm.vue?vue&type=script&lang=js"
export * from "./EmployeeForm.vue?vue&type=script&lang=js"
import style0 from "./EmployeeForm.vue?vue&type=style&index=0&id=01217aa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01217aa1",
  null
  
)

export default component.exports